import React from "react"
import {
  Formik,
  Form as FormikForm,
  Field,
  //useFormikContext
} from "formik"
import * as Yup from "yup"
import * as Constants from "../../../common/constants"
import FormTextbox from "../WindscreenClaim/components/formTextbox"
import FormFieldDisableAutoComplete from "../WindscreenClaim/components/formFieldDisableAutoComplete"
import FormMobileTextBox from "../WindscreenClaim/components/formMobileTextBox"
import FormRadioButtonClaimData from "../WindscreenClaim/components/formRadioButtonClaimData"
import FormDropdownArray from "../WindscreenClaim/components/formDropdownArray"
import { useDispatch } from "react-redux"
import { controlEditBenefit } from "../../../Redux/WindscreenClaim/actions"
import { Row, Col } from "react-bootstrap"
import EditBenefitImg from "../../../content/img/editBenefit.png"

const DriverInformation = React.memo(({ claimData, uiData }) => {
  const { pageNumber, editBenefits, clickedNext, occupationList } = uiData
  const category = "claimInfo"
  const details = "policyInfo"
  const formName = "Particulars of Driver"
  const dispatch = useDispatch()

  const formClickedNext = clickedNext[formName]

  const driverInfoSchema = Yup.object().shape(
    {
      driverName: Yup.string()
        .required(Constants.driverNameErrorMsg)
        .matches(Constants.namepattern, Constants.driverNameErrorMsg),

      driverIC: Yup.string()
        .required(Constants.driverICErrorMsg)
        .matches(Constants.nricpattern, Constants.driverICErrorMsg),
      driverAddress: Yup.string().required(Constants.driverAddressErrorMsg),
      driverOccupation: Yup.string().required(
        Constants.driverOccupationErrorMsg
      ),
      otherDriverOccupation: Yup.string().when("driverOccupation", {
        is: value => value === "Others",
        then: Yup.string().required(Constants.otherDriverOccupationErrorMsg),
      }),
      driverMobileNo: Yup.string().when(
        ["driverResidentialTelNo", "driverBusinessTelNo"],
        {
          is: (driverResidentialTelNo, driverBusinessTelNo) =>
            !driverResidentialTelNo && !driverBusinessTelNo,
          then: Yup.string()
            .required("Please enter at least one phone number.")
            .matches(Constants.mobilepattern, Constants.driverMobileNoErrorMsg),
        }
      ),
      driverResidentialTelNo: Yup.string().when(
        ["driverMobileNo", "driverBusinessTelNo"],
        {
          is: (driverMobileNo, driverBusinessTelNo) =>
            !driverMobileNo && !driverBusinessTelNo,
          then: Yup.string().required(
            "Please enter at least one phone number."
          ),
          //.matches(Constants.mobilepattern, Constants.driverMobileNoErrorMsg),
        }
      ),
      driverBusinessTelNo: Yup.string().when(
        ["driverMobileNo", "driverResidentialTelNo"],
        {
          is: (driverMobileNo, driverResidentialTelNo) =>
            !driverMobileNo && !driverResidentialTelNo,
          then: Yup.string().required(
            "Please enter at least one phone number."
          ),
          //.matches(Constants.mobilepattern, Constants.driverMobileNoErrorMsg),
        }
      ),
    },
    [
      ["driverResidentialTelNo", "driverBusinessTelNo"],
      ["driverMobileNo", "driverBusinessTelNo"],
      ["driverMobileNo", "driverResidentialTelNo"],
    ]
  )

  return (
    <Formik
      initialValues={claimData[category][details]}
      enableReinitialize={true}
      validationSchema={driverInfoSchema}
      validateOnMount={true}
    >
      {({ handleSubmit, isValid, values }) => (
        <div>
          <Row
            className={
              "col-xs-12 bigScreenNarrowing form-group ReviewChoosedDetailDiv " +
              (pageNumber === 5 && !editBenefits[formName] ? "" : "hide")
            }
          >
            <div className="col-md-10 col-8 summaryBenefit">
              <b> {formName} </b>
            </div>
            <div className="col-md-2 col-4 row noMarginLeftRightSmallScreen">
              <div className="col-12 pr-0">
                <img
                  className="editBtn"
                  src={EditBenefitImg}
                  alt=""
                  onClick={() => {
                    dispatch(controlEditBenefit(formName))
                  }}
                ></img>
              </div>
            </div>
          </Row>
          <FormikForm onSubmit={handleSubmit}>
            <Row
              className={
                pageNumber === 3 || (pageNumber === 5 && editBenefits[formName])
                  ? ""
                  : "hide"
              }
            >
              <div
                className={
                  "title text-center MarginTop75 " +
                  (pageNumber === 3 ? "" : "hide")
                }
              >
                Submit online windscreen claim
              </div>
              <Row
                className={
                  "containerBody " +
                  (pageNumber === 5
                    ? "blueBG summaryContainerBody mb-4 "
                    : "marginTop3x")
                }
              >
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="formContainer"
                >
                  <div
                    className={
                      "horizontal-align marginBottom1x " +
                      (pageNumber === 3 ||
                      (pageNumber === 5 && editBenefits[formName])
                        ? ""
                        : "hide")
                    }
                  >
                    <Col xs={12} md={12}>
                      <div
                        className={
                          "titleText " + (pageNumber === 5 ? "hide" : "")
                        }
                      >
                        Particulars of Driver
                      </div>
                    </Col>
                  </div>
                  {
                    <Row
                      className={
                        "form-group " + (editBenefits[formName] ? "" : "hide")
                      }
                    >
                      <div className="col-md-9 col-7 textforinput marginTop10px benefitEditTitle">
                        <p>{formName}</p>
                      </div>
                      <div className="col-md-3 col-5 marginTop10px">
                        <div
                          className="cursorPointer"
                          role="button"
                          tabIndex="0"
                          onClick={() => dispatch(controlEditBenefit(formName))}
                        >
                          <p className="doneEdit">DONE EDIT</p>
                        </div>
                      </div>
                    </Row>
                  }
                  {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc={"Driver's Name"}
                    coverageCategory={category}
                    coverageCode={details}
                    maxLength={50}
                    name="driverName"
                    component={FormTextbox}
                    formIsValid={isValid}
                    formName={formName}
                    clickedNext={formClickedNext}
                    toUpperCase={true}
                  />
                  <Field
                    textDesc={"Driver's NRIC No."}
                    coverageCategory={category}
                    coverageCode={details}
                    maxLength={20}
                    name="driverIC"
                    component={FormTextbox}
                    formIsValid={isValid}
                    formName={formName}
                    clickedNext={formClickedNext}
                    toUpperCase={true}
                  />
                  <Field
                    textDesc={"Driver's Address"}
                    coverageCategory={category}
                    coverageCode={details}
                    maxLength={100}
                    name="driverAddress"
                    component={FormTextbox}
                    formIsValid={isValid}
                    formName={formName}
                    clickedNext={formClickedNext}
                    toUpperCase={false}
                  />

                  <Field
                    textDesc={"Driver's Occupation"}
                    coverageCategory={category}
                    coverageCode={details}
                    name="driverOccupation"
                    component={FormDropdownArray}
                    propertyName={"Occupation"}
                    dropdownItem={occupationList}
                    formIsValid={isValid}
                    formName={formName}
                    clickedNext={formClickedNext}
                    extraFieldValue={["Others"]}
                    affectedField={["otherDriverOccupation"]}
                  />
                  {values.driverOccupation &&
                    values.driverOccupation === "Others" && (
                      <>
                        {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                        <Field
                          textDesc={"Disable Auto Complete"}
                          name="disableAutoComplete"
                          component={FormFieldDisableAutoComplete}
                        />
                        <Field
                          textDesc={"Other Driver's Occupation"}
                          coverageCategory={category}
                          coverageCode={details}
                          maxLength={50}
                          name="otherDriverOccupation"
                          component={FormTextbox}
                          formIsValid={isValid}
                          formName={formName}
                          clickedNext={formClickedNext}
                          toUpperCase={false}
                        />
                      </>
                    )}

                  <Field
                    textDesc={"Driver's Mobile No."}
                    coverageCategory={category}
                    coverageCode={details}
                    maxLength={9}
                    name="driverMobileNo"
                    component={FormMobileTextBox}
                    formIsValid={isValid}
                    formName={formName}
                    clickedNext={formClickedNext}
                  />
                  <Field
                    textDesc={"Driver's Residential Tel No."}
                    coverageCategory={category}
                    coverageCode={details}
                    maxLength={9}
                    name="driverResidentialTelNo"
                    component={FormMobileTextBox}
                    formIsValid={isValid}
                    formName={formName}
                    clickedNext={formClickedNext}
                  />
                  <Field
                    textDesc={"Driver's Business Tel No."}
                    coverageCategory={category}
                    coverageCode={details}
                    maxLength={9}
                    name="driverBusinessTelNo"
                    component={FormMobileTextBox}
                    formIsValid={isValid}
                    formName={formName}
                    clickedNext={formClickedNext}
                  />
                  <Field
                    textDesc="Driver authorised by owner to drive the vehicle"
                    coverageCategory={category}
                    coverageCode={details}
                    name="authorisationToDrive"
                    component={FormRadioButtonClaimData}
                    formIsValid={isValid}
                    formName={formName}
                    clickedNext={formClickedNext}
                    extraFieldValue={[false]}
                  />
                </Col>
              </Row>
            </Row>
          </FormikForm>
        </div>
      )}
    </Formik>
  )
})
export default DriverInformation
